export const crop = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M7 9V20L8 21H19V25.5H21V21H25.5V19H21V8L20 7L9 7V2.5H7V7H2.5V9H7ZM9 9V19H19V9L9 9Z"
    fill="currentColor"
  />
);
